import { render, staticRenderFns } from "./SiteDetailView.vue?vue&type=template&id=c89c9860&scoped=true&"
import script from "./SiteDetailView.vue?vue&type=script&lang=js&"
export * from "./SiteDetailView.vue?vue&type=script&lang=js&"
import style0 from "./SiteDetailView.vue?vue&type=style&index=0&id=c89c9860&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c89c9860",
  null
  
)

export default component.exports